import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import logo_image from "../../static/logo_white_trans.png"
import title_image from "../../static/title.png"

const MenuIcon = styled.button`
position: absolute;
top: 1rem;
display: flex;
flex-direction: column;
justify-content: space-around;
width: 3.5rem;
height: 3.5rem;
background: transparent;
border: none;
cursor: pointer;
z-index: 5;

div {
	width: 2.5rem;
	height: .2rem;
	background: white;
	border-radius: 5px;
	transform-origin: 1px;
	position: relative;
	transition: opacity 300ms, transform 300ms;
	
	:first-child {
		transform: ${({ nav }) => nav ? 'rotate(45deg)' : 'rotate(0)'}
	}

		:nth-child(2) {
			opacity: ${({ nav }) => nav ? "0" : "1"}
		}

		:nth-child(3) {
		transform: ${({ nav }) => nav ? 'rotate(-45deg)' : 'rotate(0)'}
		}
}
`
const MenuLinks = styled.nav`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
text-align: center;
height: 100%;
width: 100%;
transition: transform 300ms;
background: #d7d7d7;
position: absolute;
top: 0;
right: 0;
width: 100%;
transform: ${({ nav }) => (nav ? "translateX(0)" : "translateX(100%)")};

ul {
	list-style-type: none;
}

li {
	margin-top: 1rem;
}

a {
	text-decoration: none;
	color: black;
	font-size: 1.5rem;
	transition: color 300ms;

	:hover {
		color: red;
	}
}
`

const Header = () => {
	const [nav, showNav] = useState(false)

	return (
		<div id='header' style={{ height: '100%', backgroundColor: 'black', display: 'grid', gridTemplateColumns: '20% 60% 20%' }}>
			<div id='logo' style={{ width: '100%' }} >
				<img alt='logo' src={logo_image} style={{ maxHeight: '15vh', maxWidth: '100%', width: 'auto !important' }} />
			</div>
			<div id='title' style={{ position: 'relative', margin: '0 auto', textAlign: 'center' }}>
				<img alt='title' src={title_image} style={{ maxHeight: '15vh', maxWidth: '100%', width: 'auto !important' }} />
			</div>
			<div id='menu' style={{ width: '100%' }}>
				<MenuIcon nav={nav} onClick={() => showNav(!nav)}>
					<div />
					<div />
					<div />
				</MenuIcon>
				<MenuLinks nav={nav}>
					<ul>
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/archives">Archives</Link>
						</li>
						<li>
							<Link to="/contact">Contact</Link>
						</li>
						<li>
							<Link to="/education">Education</Link>
						</li>
						<li>
							<Link to="/live_shows">Live Shows</Link>
						</li>
						<li>
							<Link to="/meet_team">Meet The Team</Link>
						</li>
						<li>
							<Link to="/merch">Merchandise</Link>
						</li>
						<li>
							<Link to="/music">Music</Link>
						</li>
						<li>
							<Link to="/news">News</Link>
						</li>
						<li>
							<Link to="/nfts">NFTs</Link>
						</li>
						<li>
							<Link to="/roster">Roster</Link>
						</li>
						<li>
							<Link to="/samples">Samples</Link>
						</li>
						<li>
							<Link to="/team_profiles">Team Profiles</Link>
						</li>
						<li>
							<Link to="/top_lines">Top Lines</Link>
						</li>
						<li>
							<Link to="/upcoming_music">Upcoming Music</Link>
						</li>
					</ul>
				</MenuLinks>
			</div>
		</div >
	)
}

export default Header
